import { render, staticRenderFns } from "./InvestigationSequenceForm.vue?vue&type=template&id=6fb6ccb4&scoped=true&"
import script from "./InvestigationSequenceForm.vue?vue&type=script&lang=js&"
export * from "./InvestigationSequenceForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationSequenceForm.vue?vue&type=style&index=0&id=6fb6ccb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6ccb4",
  null
  
)

export default component.exports